@if (context.visit.visitDeclaration.portVisit.berthVisits.length > 0 ) {
  @if (areNauticalServicesApplicable(context.visit.portOfCall.port.locationUnCode)) {
    <div class="row declaration-block"
      >
      @if (hasPilots(context.visit.portOfCall.port.locationUnCode)) {
        <div class="col-md-4">
          @if (pilotNotPossible) {
            <app-status-alert type="warning">
              Please note that the Entry point is {{context.visit.visitDeclaration.portVisit.entryPoint?.name}}. In this case the pilotage for the incoming voyage needs to be requested at the outgoing voyage of the previous visit.
            </app-status-alert>
          }
          <app-edit-nautical-service [(ngModel)]="context.visit.visitDeclaration.portVisit.firstMovement.pilotService"
            type="Pilot" [serviceProviders]="pilotProvider" id="pilot-incoming-movement"
            [isFirstMovement]="true">
          </app-edit-nautical-service>
        </div>
      }
      @if (hasTugboats(context.visit.portOfCall.port.locationUnCode) || hasHelmsmen(context.visit.portOfCall.port.locationUnCode)) {
        <div class="col-md-4">
          @if (hasTugboats(context.visit.portOfCall.port.locationUnCode)) {
            <app-edit-nautical-service
              [(ngModel)]="context.visit.visitDeclaration.portVisit.berthVisits[0].tugboatAtArrival"
              type="Tugboat" [serviceProviders]="tugboatProvider" id="tugboats-incoming-movement">
            </app-edit-nautical-service>
          }
          @if (hasHelmsmen(context.visit.portOfCall.port.locationUnCode)) {
            <app-edit-nautical-service class="d-block mt-3"
              [(ngModel)]="context.visit.visitDeclaration.portVisit.berthVisits[0].helmsmenAtArrival"
              type="Helmsmen" [serviceProviders]="helmsmenProvider" id="helmsmen-incoming-movement">
            </app-edit-nautical-service>
          }
        </div>
      }
      @if (hasBoatmen(context.visit.portOfCall.port.locationUnCode)) {
        <div class="col-md-4">
          <app-edit-nautical-service [(ngModel)]="context.visit.visitDeclaration.portVisit.berthVisits[0].boatmenAtArrival"
            type="Boatmen" [serviceProviders]="boatmenProvider" id="boatmen-incoming-movement">
          </app-edit-nautical-service>
        </div>
      }
    </div>
  }
} @else {
  @if (areNauticalServicesApplicable(context.visit.portOfCall.port.locationUnCode)) {
    <div class="row declaration-block"
      >
      @if (hasPilots(context.visit.portOfCall.port.locationUnCode)) {
        <div class="col-md-4">
          <app-edit-nautical-service [(ngModel)]="context.visit.visitDeclaration.portVisit.firstMovement.pilotService"
            type="Pilot" [serviceProviders]="pilotProvider" required id="pilot-passingThrough">
          </app-edit-nautical-service>
        </div>
      }
      @if (hasTugboats(context.visit.portOfCall.port.locationUnCode)) {
        <div class="col-md-4">
          <app-edit-nautical-service [(ngModel)]="context.visit.visitDeclaration.portVisit.passingThroughTugboats" required
            type="Tugboat" [serviceProviders]="tugboatProvider" id="tugboats-passingThrough">
          </app-edit-nautical-service>
        </div>
      }
      <div class="col-md-4">
        <div class="card card-body">
          Boatmen not applicable when passing through port
        </div>
      </div>
    </div>
  }
}

